<script lang="ts" setup>
import {NSelect} from 'naive-ui';
import {useLanguageStore} from "@/stores/language-store";
import {enumToNavigator, Language, LanguageOptions} from "@/constants/language";
import {useI18n} from "vue-i18n";
import {useAuthStore} from "@/stores/authentication-store";
import {computed} from "vue";

const authStore = useAuthStore();
const languageStore = useLanguageStore();
const i18n = useI18n();

const languageOptions = computed(() => {
    return LanguageOptions.map(option => ({...option, label: i18n.t(option.label)}));
});

const switchLanguage = async (language: Language) => {
  i18n.locale.value = enumToNavigator(language);
  await languageStore.switchLanguage(language, authStore.userId);
  //Set ui language
  window.location.reload()
}
</script>

<template>
  <n-select v-model:value="languageStore.currentLang" :options="languageOptions" placeholder=""
            @update-value="switchLanguage">
  </n-select>
</template>

<style lang="scss" scoped>

</style>
